<template>
  <div class="crewHome">
    <div
      class="crewDetail-content"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.3)"
    >
      <div class="crewDetail-right">
        <div class="right-header">
          <img
            v-if="!imageUrl"
            src="@/assets/other-crew-header.png"
            alt=""
            style="width: 70px; height: 70px; border-radius: 50%"
          />
          <img
            v-if="imageUrl"
            :src="imageUrl"
            alt=""
            style="width: 70px; height: 70px; border-radius: 50%"
          />
          <div style="margin-left: 11px">
            <p class="right-header-name">{{ baseList.userNameCn }}</p>
            <div class="right-header-mess">
              <img
                src="@/assets/other-crew-sex.png"
                alt=""
                style="width: 16px; height: 18px"
              />
              <span style="margin-left: 11px" v-if="baseList.sex == 0"
                >男 ·
              </span>
              <span style="margin-left: 11px" v-if="baseList.sex == 1"
                >女 ·
              </span>
              <span style="margin-left: 11px" v-if="!baseList">-- · </span>
              <span style="margin-left: 5px">{{ baseList.idCardNo }}</span>
              <img
                src="@/assets/other-crew-phone.png"
                alt=""
                style="width: 12px; height: 18px; margin-left: 23px"
              />
              <span style="margin-left: 11px">{{ baseList.cellphoneNo }}</span>
              <img
                src="@/assets/other-crew-email.png"
                alt=""
                style="width: 17px; height: 12px; margin-left: 23px"
              />
              <span style="margin-left: 11px">{{
                baseList.email || "--"
              }}</span>
              <img
                src="@/assets/other-crew-backpack.png"
                alt=""
                style="width: 16px; height: 14px; margin-left: 23px"
              />
              <span style="margin-left: 11px"
                >当前状态: <span v-if="baseList.crewState == 1">在职</span
                ><span v-if="baseList.crewState == 2">离职</span></span
              ><span v-if="!baseList.crewState">--</span>
            </div>
          </div>
          <div class="other-crew-button" v-if="passFlag != '2'">
            <div class="other-add-crewList" @click="choseCom()">通过</div>
            <!-- <div class="other-crew-download">下载</div> -->
            <div class="other-del-list" @click="delInvite()">淘汰</div>
          </div>
        </div>
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="other-tabs"
        >
          <el-tab-pane label="简历信息" name="first">
            <div class="other-crew-base">
              <div class="other-base-title">
                <span class="other-base-ball"></span>
                基本信息
              </div>
              <table class="other-baseList">
                <tr>
                  <td>姓名:</td>
                  <td>{{ baseList.userNameCn }}</td>
                  <td>性别:</td>
                  <td>
                    <span v-if="!baseList.sex">--</span>
                    <span v-if="baseList.sex == 0">男</span>
                    <span v-if="baseList.sex == 1">女</span>
                  </td>
                  <td>身份证号:</td>
                  <td>{{ baseList.idCardNo || "--" }}</td>
                  <td>手机号码:</td>
                  <td>{{ baseList.cellphoneNo || "--" }}</td>
                </tr>
                <tr>
                  <td>常用邮箱:</td>
                  <td>{{ baseList.email || "--" }}</td>
                  <td>出生日期:</td>
                  <td>{{ baseList.dateOfBirth || "--" }}</td>
                  <td>是否婚配:</td>
                  <td>
                    <span v-if="baseList.isMarried == 0">未婚</span>
                    <span v-if="baseList.isMarried == 1">已婚</span>
                    <span v-if="!baseList.isMarried">--</span>
                  </td>
                  <td>民族:</td>
                  <td>{{ baseList.nation || "--" }}</td>
                </tr>
                <tr>
                  <td>航海经验:</td>
                  <td>{{ baseList.sailExperienceName || "--" }}</td>
                  <td>健康状况:</td>
                  <td>{{ baseList.healthRemark || "--" }}</td>
                  <td>籍贯:</td>
                  <td>{{ baseList.nativePlace || "--" }}</td>
                  <td>家庭住址:</td>
                  <td>{{ baseList.homeAddress || "--" }}</td>
                </tr>
                <tr>
                  <td>学历:</td>
                  <td>{{ baseList.highestEducationName || "--" }}</td>
                  <td>毕业院校:</td>
                  <td>{{ baseList.highestGraduateSchool || "--" }}</td>
                  <td>专业:</td>
                  <td>{{ baseList.highestMajor || "--" }}</td>
                  <td>毕业时间:</td>
                  <td>{{ baseList.highestGraduateTime || "--" }}</td>
                </tr>
                <tr>
                  <td>是否属于本公司:</td>
                  <td>
                    <span v-if="baseList.userState == 1">是</span>
                    <span v-if="baseList.userState == 2">否 </span>
                    <span v-if="!baseList.userState">--</span>
                  </td>
                  <td>工作服尺寸:</td>
                  <td>{{ baseList.waistLine || "--" }}</td>
                  <td>工作鞋尺码:</td>
                  <td>{{ baseList.shoesSize || "--" }}</td>
                  <td>家属姓名:</td>
                  <td>{{ baseList.emergencyContactName || "--" }}</td>
                </tr>
                <tr>
                  <td>家属联系方式:</td>
                  <td>{{ baseList.emergencyContact || "--" }}</td>
                </tr>
              </table>
            </div>
            <div
              style="
                height: 1px;
                width: 100%;
                background: #f0f0f0;
                margin-top: 16px;
              "
            ></div>
            <div class="other-crew-base" style="margin-top: 25px">
              <div class="other-base-title">
                <span class="other-base-ball"></span>
                求职意向
              </div>
              <table class="other-baseList">
                <tr>
                  <td>意向职位:</td>
                  <td>{{ resumeInfo.positionName || "--" }}</td>
                  <td>船舶类型:</td>
                  <td>{{ resumeInfo.shipTypeName || "--" }}</td>
                  <td>航区要求:</td>
                  <td>{{ resumeInfo.naviAreaName || "--" }}</td>
                  <td>船龄要求:</td>
                  <td>{{ resumeInfo.shipAgeName || "--" }}</td>
                </tr>
                <tr>
                  <td>船舶总吨:</td>
                  <td>
                    {{ resumeInfo.recuritShipTonName }}
                  </td>
                  <td>期望月薪:</td>
                  <td>
                    {{ resumeInfo.salaryBegin || "" }} --
                    {{ resumeInfo.salaryEnd || "" }}
                  </td>

                  <td>月薪单位:</td>
                  <td>
                    <span v-if="resumeInfo.salaryType == 1">人民币</span>
                    <span v-if="resumeInfo.salaryType == 2">美元</span>
                    <span v-if="!resumeInfo.salaryType">--</span>
                  </td>
                  <td>登船地点</td>
                  <td>{{ resumeInfo.locationPortName || "--" }}</td>
                </tr>
                <tr>
                  <td>其他说明</td>
                  <td>{{ resumeInfo.remark || "--" }}</td>
                </tr>
              </table>
            </div>
            <div
              style="
                height: 1px;
                width: 100%;
                background: #f0f0f0;
                margin-top: 16px;
              "
            ></div>
            <div class="other-crew-base" style="margin-top: 25px">
              <div class="other-cert-title">
                <div>
                  <span class="other-base-ball"></span>
                  持有证书
                </div>
                <span
                  class="other-arrow-up"
                  @click="arrowUp()"
                  v-if="certVisible"
                  >收起<i class="el-icon-arrow-up"></i
                ></span>
                <span
                  class="other-arrow-up"
                  @click="arrowDown()"
                  v-if="!certVisible"
                  >展开<i class="el-icon-arrow-down"></i
                ></span>
              </div>
              <div style="width: 100%" v-if="certVisible">
                <div v-if="resposeType == 2 || crewCertificateList.length > 0">
                  <div v-for="item in crewCertificateList" :key="item.id">
                    <div class="other-cedit-title">
                      <span>{{ item.certName || "--" }}</span>
                      <span
                        >{{ item.issueTime }} -
                        {{ item.effectiveTime || "永久有效" }}</span
                      >
                    </div>
                    <div class="other-cedit-content">
                      <span>证书号码:</span>
                      <span>{{ item.certNo }}</span>
                      <span>证书类型:</span>
                      <span>{{ item.certTypeName }}</span>
                      <span>签发机构:</span>
                      <span>{{ item.issueOrgName }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="passCert-detail"
                  v-if="resposeType != 2 && crewCertificateList.length == 0"
                >
                  <span>授权后即可获取本人证书</span
                  ><span @click="resposePass()">请求授权</span>
                </div>
              </div>
            </div>
            <div
              style="
                height: 1px;
                width: 100%;
                background: #f0f0f0;
                margin-top: 16px;
              "
            ></div>
            <div class="other-crew-base" style="margin-top: 25px">
              <div class="other-cert-title">
                <div>
                  <span class="other-base-ball"></span>
                  工作经历
                </div>
                <span
                  class="other-arrow-up"
                  @click="arrowSeaUp()"
                  v-if="seaVisible"
                  >收起<i class="el-icon-arrow-up"></i
                ></span>
                <span
                  class="other-arrow-up"
                  @click="arrowSeaUp()"
                  v-if="!seaVisible"
                  >展开<i class="el-icon-arrow-down"></i
                ></span>
              </div>
              <div style="width: 100%" v-if="seaVisible">
                <div v-for="item in recruitCyServqualiList" :key="item.id">
                  <div class="other-cedit-title">
                    <span>{{ item.servCompyName }}</span>
                    <span>{{ item.offiDate }} - {{ item.dismissData }} </span>
                  </div>
                  <div class="other-cedit-content">
                    <span>任职职务:</span>
                    <span>{{ item.offiDutyName }}</span>
                    <span>船舶种类:</span>
                    <span>{{ item.shipTypeName }}</span>
                    <span>船舶航区:</span>
                    <span>{{ item.naviAreaName }}</span>
                    <span>船舶总吨:</span>
                    <span v-if="item.shipTon">{{ item.shipTon }}吨</span>
                    <span>主机功率:</span>
                    <span>{{ item.shipZjgl }}KW</span>
                  </div>
                </div>
              </div>

              <div
                style="
                  height: 1px;
                  width: 100%;
                  background: #f0f0f0;
                  margin-top: 16px;
                "
              ></div>
              <div class="other-crew-base" style="margin-top: 25px">
                <div class="other-cert-title">
                  <div>
                    <span class="other-base-ball"></span>
                    附件
                  </div>
                </div>
                <div style="width: 100%" v-if="baseList.relateFile">
                  <span
                    v-for="item in baseList.relateFile"
                    :key="item.fileUrl"
                    class="relate-file"
                    @click="openShipFile(item.fileUrl)"
                    >{{ item.fileName }}</span
                  >
                </div>
              </div>
              <div
                style="
                  height: 1px;
                  width: 100%;
                  background: #f0f0f0;
                  margin-top: 16px;
                "
              ></div>
              <div class="other-crew-base" style="margin-top: 25px">
                <div class="other-cert-title">
                  <div>
                    <span class="other-base-ball"></span>
                    船员附件
                  </div>
                </div>
                <div class="tabLists">
                  <div style="display: flex">
                    <div
                      class="tab"
                      v-for="item in tabList2"
                      :key="item"
                      @click="clickTab2(item)"
                      :class="activeName2 == item ? 'choseTab' : ''"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
                <el-table
                  :data="fileData"
                  border
                  style="
                    width: 100%;
                    overflow-y: scroll;
                    margin-top: 6px;
                    font-size: 12px !important;
                  "
                >
                  <el-table-column
                    prop="fileName"
                    show-overflow-tooltip
                    width="200"
                    label="证书名称"
                    v-if="activeName2 == '其他材料'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="fileUrlList"
                    show-overflow-tooltip
                    label="附件"
                    width="420"
                  >
                    <template slot-scope="scope">
                      <span
                        v-for="(item, index) in scope.row.fileUrlList"
                        @click="lookFileSrc2(item.url)"
                        :key="index"
                        style="color: #0079fa; cursor: pointer"
                        >{{ item.name }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="uploadTime"
                    show-overflow-tooltip
                    width="440"
                    label="上传时间"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="serviceBookCertNo"
                    show-overflow-tooltip
                    label="证书编号"
                    v-if="activeName2 == '船员服务簿'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="serviceBookIssueDate"
                    show-overflow-tooltip
                    label="签发日期"
                    v-if="activeName2 == '船员服务簿'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="serviceBookIssueDate"
                    show-overflow-tooltip
                    label="到期日期"
                    v-if="fileType == '11' || fileType == '12' || fileType == '13' || fileType == '14'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="serviceBookDeductionSituation"
                    show-overflow-tooltip
                    v-if="activeName2 == '船员服务簿'"
                    label="扣分情况"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    show-overflow-tooltip
                    label="备注"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="面试信息" name="third">
            <div class="other-crew-table">
              <el-table
                :data="tableData"
                style="width: 100%"
                header-row-class-name="other-header"
                row-class-name="other-row"
                height="100%"
              >
                <el-table-column
                  prop="recommendCompanyName"
                  label="应聘公司"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="postName"
                  label="应聘职务"
                  min-width="80"
                >
                </el-table-column>
                <!-- <el-table-column prop="date3" label="拟派船舶" min-width="80">
                </el-table-column>
                <el-table-column prop="date4" label="面试人员" min-width="100">
                </el-table-column> -->
                <el-table-column
                  prop="interviewTime"
                  label="面试时间"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="interviewState"
                  label="面试结果"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.interviewState == '1'">待面试</span>
                    <span v-if="scope.row.interviewState == '2'">通过</span>
                    <span v-if="scope.row.interviewState == '3'">未通过</span>
                  </template>
                </el-table-column>
                <el-table-column prop="fileUrl" label="附件" min-width="120">
                  <template slot-scope="scope">
                    <span
                      v-for="item in scope.row.fileUrl"
                      :key="item.fileUrl"
                      class="relate-file"
                      @click="openShipFile(item.fileUrl)"
                      >{{ item.fileName }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="任职信息" name="fourth">
            <div class="other-crew-table">
              <el-table
                :data="tableData2"
                style="width: 100%"
                header-row-class-name="other-header"
                row-class-name="other-row"
                height="100%"
              >
                <el-table-column prop="date1" label="任职公司" min-width="150">
                </el-table-column>
                <el-table-column prop="date2" label="任职职务" min-width="80">
                </el-table-column>
                <el-table-column prop="date3" label="任职船舶" min-width="80">
                </el-table-column>
                <el-table-column prop="date4" label="上船日期" min-width="100">
                </el-table-column>
                <el-table-column prop="date5" label="下船日期" min-width="100">
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <el-dialog
      class="other-dialog"
      width="450px"
      title="审核通过"
      :visible.sync="companyVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <el-form
        label-width="120px"
        :model="jobParams"
        class="other-form"
        :rules="rules"
      >
        <el-form-item label="是否属于本公司" prop="userState">
          <el-select
            v-model="jobParams.userState"
            placeholder="是否属于本公司"
            :remote-method="remoteMethod"
          >
            <el-option label="是" value="1"> </el-option>
            <el-option label="否" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="船员类型" prop="crewType">
          <el-select
            v-model="jobParams.crewType"
            placeholder="招聘职位"
            style="width: 135px"
          >
            <el-option label="自有船员" value="1"> </el-option>
            <el-option label="借调船员" value="2"> </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="companyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rememendCrewPass()"
          :loading="remendLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCrewDetail,
  getOneFile,
  crewAudit,
  currentAuthorize,
  requestAuthorize,
  getInterviewList,
  getCrewServiceFile,
} from "@/apis/index";
import { apiRoot, serveRoot } from "@/config";
const Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      activeName: "first",
      certVisible: true,
      seaVisible: true,
      tableData: [],
      tableData2: [],
      baseList: {},
      resumeInfo: {},
      imageUrl: "",
      crewCertificateList: [],
      recruitCyServqualiList: [],
      resposeType: "",
      loading: true,
      passFlag: "",
      tabList2: ["身份证件", "学历附件", "船员服务簿", "护照", "香港证书","接种证","卫检合格证"],
      activeName2: "身份证件",
      fileData: [],
      fileType: "1",
      companyVisible: false,
      remendLoading: false,
      jobParams: {},
      rules: {
        // crewType: [
        //   { required: true, message: "请选择船员类型", trigger: "blur" },
        // ],
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // console.log(this.$route.params.userId);
    if (this.$route.params.passFlag) {
      this.passFlag = this.$route.params.passFlag;
    }
    this.getCrewDetailList();
    // this.currentAuthorizeList();
    this.getInterviewListOne();
    this.getCrewServiceFileList();
  },
  methods: {
    clickTab2(item) {
      this.activeName2 = item;
      this.getCrewServiceFileList();
    },
    async getCrewServiceFileList() {
      this.fileType = "";
      // tabList2:["身份证件","学历附件","船员服务簿","党团类材料","政审材料","考核鉴定类","表彰奖励类","违规违纪类","任免材料","其他材料"],
      if (this.activeName2 == "身份证件") {
        this.fileType = "1";
      } else if (this.activeName2 == "学历附件") {
        this.fileType = "2";
      } else if (this.activeName2 == "船员服务簿") {
        this.fileType = "3";
      } else if (this.activeName2 == "党团类材料") {
        this.fileType = "4";
      } else if (this.activeName2 == "政审材料") {
        this.fileType = "5";
      } else if (this.activeName2 == "考核鉴定类") {
        this.fileType = "6";
      } else if (this.activeName2 == "表彰奖励类") {
        this.fileType = "7";
      } else if (this.activeName2 == "违规违纪类") {
        this.fileType = "8";
      } else if (this.activeName2 == "任免材料") {
        this.fileType = "9";
      } else if (this.activeName2 == "其他材料") {
        this.fileType = "10";
      } else if (this.activeName2 == "护照") {
        this.fileType = "11";
      } else if (this.activeName2 == "香港证书") {
        this.fileType = "12";
      } else if (this.activeName2 == "接种证") {
        this.fileType = "13";
      } else if (this.activeName2 == "卫检合格证") {
        this.fileType = "14";
      }
      let params = {
        // id: this.info.id,
        userId: this.$route.params.userId,
        fileType: this.fileType,
      };
      const res = await getCrewServiceFile(params);
      res.data.forEach((el) => {
        el.fileUrlList = el.fileUrl ? JSON.parse(el.fileUrl) : [];
        // el.fileUrlList = el.fileUrl
      });
      // console.log(res)
      this.fileData = res.data;
      // this.certList = res.data;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //学历
    async getCrewDetailList() {
      let userId = this.$route.params.userId;
      this.loading = true;
      const res = await getCrewDetail({ userId: userId });
      if (res.code == 1) {
        this.baseList = res.data.compyUserInfo || {};
        this.resumeInfo = res.data.resumeInfo || {};
        this.crewCertificateList = res.data.crewCertificateList || [];
        this.recruitCyServqualiList = res.data.recruitCyServqualiList || [];
        this.loading = false;
        if (this.baseList.relateFile) {
          this.baseList.relateFile = JSON.parse(this.baseList.relateFile);
          console.log(this.baseList.relateFile);
        }
        // console.log(this.baseList.userPhoto);
        if (!(this.baseList.userPhoto.indexOf("_on") > -1)) {
          this.imageUrl = apiRoot + this.baseList.userPhoto;
        } else if (
          this.baseList.userPhoto &&
          this.baseList.userPhoto.indexOf("_on") > -1
        ) {
          this.lookFileSrc(this.baseList.userPhoto);
        }
        this.currentAuthorizeList();
      } else {
        this.loading = false;
      }
    },
    async openShipFile(src) {
      let res = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      window.open(res.data);
    },
    arrowUp() {
      this.certVisible = !this.certVisible;
    },
    arrowDown() {
      this.certVisible = !this.certVisible;
    },
    arrowSeaUp() {
      this.seaVisible = !this.seaVisible;
    },
    arrowSeaDown() {
      this.seaVisible = !this.seaVisible;
    },
    async lookFileSrc(src) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      this.imageUrl = url.data;
      // if (url) {
      //   window.open(url);
      // }
    },
    async lookFileSrc2(src) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      // this.imageUrl = url.data;
      if (url) {
        window.open(url.data);
      }
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    async rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      let params = {
        agentAuditState: "2",
        userId: this.baseList.userId,
      };
      if (this.$route.params.agentCyAuditId) {
        params.userOrigin = "2";
        params.agentCyAuditId = this.$route.params.agentCyAuditId;
      } else if (this.$route.params.cyResumeSendId) {
        params.userOrigin = "3";
        params.cyResumeSendId = this.$route.params.cyResumeSendId;
      }
      params.userState = this.jobParams.userState;
      this.remendLoading = true;
      let res = await crewAudit(params);
      if (res.code == 1) {
        this.$message({
          message: "加入成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.$router.push({ name: "船员库" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
    delInvite() {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delCrewList();
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delCrewList() {
      let params = {
        agentAuditState: "3",
        userId: this.baseList.userId,
      };
      if (this.$route.params.agentCyAuditId) {
        params.userOrigin = "2";
        params.agentCyAuditId = this.$route.params.agentCyAuditId;
      } else if (this.$route.params.cyResumeSendId) {
        params.userOrigin = "3";
        params.cyResumeSendId = this.$route.params.cyResumeSendId;
      }
      // console.log(params);
      let res = await crewAudit(params);
      // console.log(res);
      if (res) {
        this.$message({
          message: "淘汰成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async currentAuthorizeList() {
      this.resposeType = "1";
      // let idCardNo = this.$route.params.idCardNo;
      let res = await currentAuthorize({
        companyId: sessionStorage.getItem("companyId"),
        idCardNo: this.baseList.idCardNo,
        authorizeType: "1",
      });
      this.resposeType = res.data || "";
      // console.log(res);
    },
    resposePass() {
      if (this.resposeType == "1") {
        this.$message({
          message: "请求授权中",
          type: "warning",
        });
        return;
      } else {
        this.getCert();
      }
    },
    async getCert() {
      this.resposeType = "1";
      const companyId = Base64.encode(sessionStorage.getItem("companyId"));
      const idCardNo = Base64.encode(this.baseList.idCardNo);
      const res = await requestAuthorize({
        authorizeType: "1",
        cellPhoneNo: this.baseList.cellphoneNo,
        idCardNo: this.baseList.idCardNo,
        url: serveRoot + `/#/passCert?companyId=${companyId}&id=${idCardNo}`,
      });
      if (res.code == 1) {
        this.$message({
          message: "请求授权成功",
          type: "success",
        });
        this.currentAuthorizeList();
      }
    },
    async getInterviewListOne() {
      let userId = this.$route.params.userId;
      let res = await getInterviewList({
        userId: userId,
      });
      // console.log(res);
      res.data.resultList.forEach((item) => {
        if (item.fileUrl) {
          item.fileUrl = JSON.parse(item.fileUrl);
        }
      });
      this.tableData = res.data.resultList;
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
